import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Gutachten from "./pages/Gutachten";
import FallDetail from "./pages/FallDetail";
import NeueAkte from "./pages/NeueAkte";
import Akten from "./pages/Akten";
import Fahrzeuge from "./pages/Fahrzeuge";
import Kunden from "./pages/Kunden";
import Termine from "./pages/Termine";
import Statistiken from "./pages/Statistiken";
import Einstellungen from "./pages/Einstellungen";
import Unternehmen from "./pages/Unternehmen";
import Support from "./pages/Support";
import Chat from "./pages/Chat";
import Dokumente from "./pages/Dokumente";
import Verbesserung from "./pages/Verbesserung";
import Schulung from "./pages/Schulung";
import Buchhaltung from "./pages/Buchhaltung";
import Aufgaben from "./pages/Aufgaben";
import SuperadminKalkulation from "./pages/SuperadminKalkulation";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminKalkulationen from "./pages/admin/AdminKalkulationen";
import AdminAkten from "./pages/admin/AdminAkten";
import AdminBenutzer from "./pages/admin/AdminBenutzer";
import AdminRechnungen from "./pages/admin/AdminRechnungen";
import AdminEinstellungen from "./pages/admin/AdminEinstellungen";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/akten" element={<Akten />} />
          <Route path="/gutachten" element={<Gutachten />} />
          <Route path="/fall/:id" element={<FallDetail />} />
          <Route path="/faelle/neu" element={<NeueAkte />} />
          <Route path="/neue-akte" element={<NeueAkte />} />
          <Route path="/neue-akte/:akte_id" element={<NeueAkte />} />
          <Route path="/fahrzeuge" element={<Fahrzeuge />} />
          <Route path="/kunden" element={<Kunden />} />
          <Route path="/termine" element={<Termine />} />
          <Route path="/statistiken" element={<Statistiken />} />
          <Route path="/einstellungen" element={<Einstellungen />} />
          <Route path="/unternehmen" element={<Unternehmen />} />
          <Route path="/support" element={<Support />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/dokumente" element={<Dokumente />} />
          <Route path="/verbesserung" element={<Verbesserung />} />
          <Route path="/schulung" element={<Schulung />} />
          <Route path="/buchhaltung" element={<Buchhaltung />} />
          <Route path="/aufgaben" element={<Aufgaben />} />
          <Route path="/superadmin/kalkulation" element={<SuperadminKalkulation />} />
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/kalkulationen" element={<AdminKalkulationen />} />
          <Route path="/admin/kalkulationen/:id" element={<AdminKalkulationen />} />
          <Route path="/admin/akten" element={<AdminAkten />} />
          <Route path="/admin/benutzer" element={<AdminBenutzer />} />
          <Route path="/admin/rechnungen" element={<AdminRechnungen />} />
          <Route path="/admin/einstellungen" element={<AdminEinstellungen />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-left" />
    </div>
  );
}

export default App;